export { BadgeColor, BadgeType } from './Badge.consts';
export { badgeStyles } from './Badge.styles';
export { default as Badge } from './Badge';
